import React from "react";

const SECTORS = [
  "Banque & Finance",
  "Assurance",
  "Télécommunications",
  "Administration publique",
  "Énergie & Mines",
  "Santé",
  "Industrie & Logistique",
  "Microfinance",
  "Grande distribution",
  "Éducation",
];

export default function Sectors() {
  const items = [...SECTORS, ...SECTORS];
  return (
    <section
      id="secteurs"
      data-testid="sectors-section"
      className="relative bg-[#050a18] border-y border-[#D4AF37]/15 py-16 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12 mb-8 md:mb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div>
            <div className="overline text-[#D4AF37]">── Secteurs accompagnés</div>
            <h2 className="font-display text-[28px] sm:text-3xl md:text-4xl font-black tracking-tight mt-3 text-[#F5F5F5] leading-[1.1]">
              Des références dans les industries les plus exigeantes.
            </h2>
          </div>
          <p className="text-[#F5F5F5]/65 max-w-sm text-[14px] sm:text-[15px]">
            De la banque centrale à la microfinance rurale — nous parlons le
            langage de votre métier.
          </p>
        </div>
      </div>

      <div className="marquee-fade">
        <div className="flex w-max ticker-track">
          {items.map((s, i) => (
            <div
              key={i}
              data-testid={`sector-${i}`}
              className="flex items-center gap-4 sm:gap-6 px-6 sm:px-8 py-3 sm:py-4 whitespace-nowrap"
            >
              <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-[#D4AF37]" />
              <span className="font-display text-xl sm:text-2xl md:text-3xl font-extrabold tracking-tight text-[#F5F5F5]">
                {s}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
